<template>
  <div class="container">
    <div ref="threeContainer"></div>
  </div>
</template>

<script>

import {
    THREE,
  GLTFLoader,
  Scene,
  TrackballControls,
  PerspectiveCamera,
  WebGLRenderer,
  Color,
  FogExp2,
  CylinderBufferGeometry,
  MeshPhongMaterial,
  Mesh,
  DirectionalLight,
  AmbientLight,
  LineBasicMaterial,
  Geometry,
  Vector3,
  Line
} from "three-full";


export default {
  name: 'MyModel',
  data() {
    return {
      scene: null,
      camera: null,
      renderer: null,
      model: null
    };
  },
  mounted() {
    // Create a scene
    this.scene = new THREE.Scene();

    // Create a camera
    this.camera = new THREE.PerspectiveCamera(
      75,
      this.$refs.threeContainer.clientWidth / this.$refs.threeContainer.clientHeight,
      0.1,
      1000
    );

    // Create a renderer
    this.renderer = new THREE.WebGLRenderer();
    this.renderer.setSize(
      this.$refs.threeContainer.clientWidth,
      this.$refs.threeContainer.clientHeight
    );
    this.$refs.threeContainer.appendChild(this.renderer.domElement);

    // Load a 3D model
    let loader = new THREE.GLTFLoader();
    loader.load('models/almond_water_redux.glb', (gltf) => {
      this.model = gltf.scene;
      this.scene.add(this.model);
      this.renderScene();
    });
  },
  methods: {
    renderScene() {
      this.renderer.render(this.scene, this.camera);
    }
  }
};
</script>

<style>
.container {
  width: 100%;
  height: 100%;
}
</style>
